var map = {
	"./modules/Navbar/locales/en.json": 857,
	"./modules/Navbar/locales/ua.json": 569,
	"./pages/ContactUs/locales/en.json": 524,
	"./pages/ContactUs/locales/ua.json": 985,
	"./pages/MVP/locales/en.json": 166,
	"./pages/MVP/locales/ua.json": 842,
	"./pages/OurTeam/locales/en.json": 101,
	"./pages/OurTeam/locales/ua.json": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;